var React = require('react');

function SuperscreenInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"strokeLinejoin":"round","d":"M18 16h-2L7 3h50l-9 13h-2M24 20v-9M40 20v-9","key":0}),React.createElement("rect",{"width":"28","height":"41","x":"18","y":"20","strokeLinejoin":"round","rx":"2","key":1}),React.createElement("path",{"d":"M18 24.6h28m-24-14h4m12 0h4","key":2})]));
}

SuperscreenInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = SuperscreenInline;

SuperscreenInline.default = SuperscreenInline;
